//GLOBAL - components from npm
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Moment from "moment";
import MicroModal from "micromodal";
import axios from "axios";
import _ from "lodash";

//COMPONENTS
import UserPhoto from "../../../components/UserPhoto/userphoto";
import TimeCounterInternal from "../../TimeCounterInternal";
import TimeCounterMinute from "../../TimeCounterMinute";

//GLOBAL STATE - redux, env...
import { Tooltippy, Topover } from "../../../actions/Tippy";
import {
  addChatSimultIndex,
  addMonitoring,
  addMonitoringSimult,
  AlterScreen,
  CallConsultaInterna,
  clearConferenceExt,
  EditTypeMonitoringm,
  EditTypeMonitorings,
  ShowInfoDisplay,
} from "../../../actions";

//ASSETS - icons, images...
import { ReactComponent as OUTLINECALL } from "../../../build/images/outline-call.svg";
import { ReactComponent as PERSON } from "../../../build/images/outline-person.svg";
import { ReactComponent as BLOQUEIO } from "../../../build/images/teams/monitorias/slash.svg";
import { ReactComponent as INTERCALAR } from "../../../build/images/teams/monitorias/message.svg";
import { ReactComponent as SUSSURRO } from "../../../build/images/teams/monitorias/profile-2user.svg";
import { ReactComponent as SIGILOSA } from "../../../build/images/teams/monitorias/sigilosa.svg";
import { ReactComponent as EMCURSO } from "../../../build/images/teams/monitorias/message-1.svg";
import { ReactComponent as FuturePauseStatic } from "../../../build/images/pause-static.svg";
import { ReactComponent as FuturePauseIcon } from "../../../build/images/pause-circle.svg";
import { ReactComponent as TempoUltimoStatus } from "../../../build/images/teams/ultimo-status.svg";
import { ReactComponent as CalendarTeam } from "../../../build/images/teams/calendar.svg";
import { ReactComponent as HorasLogin } from "../../../build/images/teams/horas-login.svg";
import { ReactComponent as Call } from "../../../build/images/teams/call.svg";
import FACEBOOK from "../../../build/images/channelsNew/facebook.svg";
import INSTAGRAM from "../../../build/images/channelsNew/instagram.svg";
import TELEGRAM from "../../../build/images/channelsNew/telegram.svg";
import WEBCHAT from "../../../build/images/channelsNew/webchat.svg";
// import WHATSAPP from "../../../build/images/channelsNew/whatsapp.svg";
import WHATSAPP from "../../../build/images/whatsapp_new3.svg";
import VOZ from "../../../build/images/channelsNew/voz.svg";
import GOOGLEGBM from "../../../build/images/channelsNew/googlegbm.svg";
import TEAMS from "../../../build/images/channelsNew/teamsBig.svg";
import WHATSAPPVOICE from "../../../build/images/whatsapp_voice.svg";
import { InitialMonitoring, SharedScreen } from "../../../actions/websocket";

const CardUser = ({
  user,
  bind,
  setUserout,
  setHoraaction,
  setDuration,
  setReasonaction,
  setActdesb,
  setInable,
  connection_platform,
  pathname,
  port,
  setIdblock,
  setIdsup,
  act,
  setAct,
  setMonitoringInfo,
  setMonitoringInfoJson,
}) => {
  //GENERAL
  const dispatch = useDispatch();
  const listCallQueue = useSelector((state) => state.listcallqueue);
  const ChatSimult = useSelector((state) => state.chatsimult);
  const InfoUsers = useSelector((state) => state.informationusers);
  const MonitoringSimult = useSelector((state) => state.monitoringsimult);
  const PermissionRouter = useSelector((state) => state.routergroups);
  const OutBandService = useSelector((state) => state.outservices);
  const StatusAgent = useSelector((state) => state.status);
  const IPCurrent = useSelector((state) => state.ipcurrent);

  //STATES
  // const [act, setAct] = useState("1");

  const datalogin = Moment().format("DD/MM/YYYY");

  //DISPATCHS ACTIONS
  function EditTypeMonitoringAction(userout, line, name, ramal, jsoncall) {
    dispatch(EditTypeMonitorings(userout, line));
    dispatch(EditTypeMonitoringm(userout, line));
    // dispatch(ShowInfoDisplay("Monitorias"));
    // dispatch(AlterScreen("Monitorias"));
    handleModalMonitoring(userout, name, ramal, jsoncall, line);
  }
  function InitialMonitoringAction(
    userin,
    userout,
    name,
    line,
    ramal,
    jsoncall,
  ) {
    // dispatch(ShowInfoDisplay("Monitorias"));
    // dispatch(AlterScreen("Monitorias"));
    handleModalMonitoring(userout, name, ramal, jsoncall, line);
    dispatch(addMonitoring(userout, name, line, ramal));
    dispatch(addMonitoringSimult(userout, name, line, ramal));
    if (line != "4") {
      const socket = InitialMonitoring(userin, userout, line, ramal);
    } else {
      const socket = SharedScreen(ramal);
    }
  }
  function AlterScreenInAction() {
    dispatch(ShowInfoDisplay("Monitorias"));
    dispatch(AlterScreen("Monitorias"));
  }
  function handleModalMonitoring(userout, name, ramal, jsoncall, line) {
    setMonitoringInfo({
      iduser: userout,
      label: name,
      ramal: ramal,
      jsoncall: jsoncall,
      monitoringLine: line,
    });
    setMonitoringInfoJson(jsoncall);
  }

  //FUNCTIONS
  function typeOfPeriod(user) {
    if (
      (user.status_sip === "RV" && user.status === "LV") ||
      (user.status_sip === "LV" && user.status === "LV") ||
      user.status_sip === null ||
      user.status === null ||
      user.status_sip === "null" ||
      user.status === "null"
    ) {
      return "HL";
    } else if (
      (user.status_sip === "LV" && user.status === "AT") ||
      (user.status_sip === "AT" && user.status === "AT") ||
      (user.status_sip === "RV" && user.status === "ATOS") ||
      (user.status_sip === "AT" && user.status === "ATOS") ||
      (user.status_sip === "ATOS" && user.status === "AT") ||
      (user.status_sip === "LV" && user.status === "RV") ||
      (user.status_sip === "CHND" && user.razao_bloqueio !== "CHND") ||
      user.status_sip === "QAT"
    ) {
      return "AT";
    } else if (user.status_sip === "BQ" && user.razao_bloqueio !== "") {
      return "HP";
    } else {
      return "ACW";
    }
  }

  function handleShowModal(e, userout, action, reasonaction, duration, status) {
    if (action === "BQSUPER") {
      MicroModal.show("modal__desbloqueio");
      duration = duration.split(" ");
      let horaaction = duration[1].split("-");
      horaaction = horaaction[0];
      duration = duration[0];
      setUserout(userout);
      setHoraaction(horaaction);
      setDuration(duration);
      setReasonaction(reasonaction);
      setAct("1001");
      setActdesb("1001");
      setInable(false);
    } else {
      if (status !== null) {
        MicroModal.show("modal__bloqueio");
        setUserout(userout);
        setAct(act);
        setInable(false);
      } else {
        axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/checkuserblock?iduser=${userout}`,
          )
          .then((response) => {
            if (response.data.durationblock === 0) {
              let idreturnblockdescription = response.data.id;
              axios
                .get(
                  `${connection_platform.type_connect}://${pathname}:${port}/conn/checkuserblocksup?iduser=${userout}`,
                )
                .then((response) => {
                  MicroModal.show("modal__desbloqueio");
                  setInable(true);
                  duration = response.data.blockingdate.split("T");
                  let horaaction = duration[1].split("-");
                  horaaction = horaaction[0];
                  duration = duration[0];
                  duration = Moment(duration, "YYYY-MM-DD").format(
                    "DD/MM/YYYY",
                  );
                  setUserout(userout);
                  setHoraaction(horaaction);
                  setDuration(duration);
                  setReasonaction(response.data.blockingreason);
                  setIdblock(idreturnblockdescription);
                  setIdsup(response.data.id);
                })
                .catch((error) => {
                  console.log("trycatch");
                });
            } else {
              setUserout(userout);
              setAct(act);
              setInable(true);
              MicroModal.show("modal__bloqueio");
            }
          })
          .catch((error) => {
            console.log("trycatch");
          });
      }
    }
  }

  function handleInitialMonitoring(
    e,
    userin,
    userout,
    name,
    monitoringsimult,
    line,
    ramal,
    jsoncall,
  ) {
    let erro = 0;
    let auxline;

    if (monitoringsimult.length != 0) {
      monitoringsimult.map((monitoring) => {
        if (parseInt(monitoring.userout) === parseInt(userout)) {
          erro = 1;
          auxline = monitoring.line;
        } else if (erro != 1) {
          erro = 0;
        }
      });
      if (erro === 1) {
        if (auxline != line) {
          EditTypeMonitoringAction(userout, line, name, ramal, jsoncall);
        }
      } else {
        InitialMonitoringAction(userin, userout, name, line, ramal, jsoncall);
      }
    } else {
      InitialMonitoringAction(userin, userout, name, line, ramal, jsoncall);
    }
    // AlterScreenInAction();
  }

  function handleInitialCall(
    e,
    permrouter,
    mediaid,
    outband,
    infouser,
    status,
    queue,
    ramal,
    ipcurrent,
    chatsimult,
    user,
  ) {
    let erro = 0;

    // checkAnswerInitial = getState().ChatSimult;

    if (chatsimult.length != 0) {
      chatsimult.map((chat) => {
        if (
          parseInt(chat.iduserout) === parseInt(user.iduser) &&
          chat.voz === false
        ) {
          erro = 1;
        } else if (
          parseInt(chat.iduserout) === parseInt(user.iduser) &&
          chat.voz === true
        ) {
          erro = 2;
        } else if (erro != 1 || erro != 2) {
          erro = 0;
        }
      });
      if (erro === 1) {
        dispatch(clearConferenceExt());
        dispatch(CallConsultaInterna(user.ramal, user.iduser, user));
      } else if (erro === 2) {
        console.log("JA POSSUI CHAT ATIVO COM VOZ");
      } else {
        let datatime = Moment().format("YYYY/MM/DD HH:mm:ss");
        dispatch(
          addChatSimultIndex(
            parseInt(user.iduser),
            user.label,
            true,
            true,
            user.ramal,
            datatime,
          ),
        );
        dispatch(CallConsultaInterna(user.ramal, user.iduser, user));
      }
    } else {
      let datatime = Moment().format("YYYY/MM/DD HH:mm:ss");
      dispatch(
        addChatSimultIndex(
          parseInt(user.iduser),
          user.label,
          true,
          true,
          user.ramal,
          datatime,
        ),
      );
      dispatch(CallConsultaInterna(user.ramal, user.iduser, user));
    }
  }

  function handleInitialChat(e, chatsimult, user) {
    let datatime = Moment().format("YYYY/MM/DD HH:mm:ss");
    dispatch(
      addChatSimultIndex(
        parseInt(user.iduser),
        user.label,
        true,
        false,
        user.ramal,
        datatime,
      ),
    );
  }

  function timeFuturePause(user, IPCurrent) {
    let duracaoFPause = "";
    let datatimeCompA = Moment().format("YYYY/MM/DD HH:mm:ss");
    const hasDuration =
      !!user &&
      !!user.duration &&
      typeof user.duration === "string" &&
      user.duration.includes("-") &&
      user.duration.split("-").length > 0;
    let arrayCompA = hasDuration ? user.duration.split("-") : [datatimeCompA];
    let dataStatusA = Moment(arrayCompA[0], "DD/MM/YYYY HH:mm:ss").format(
      "YYYY/MM/DD HH:mm:ss",
    );

    let valorDiferenca = parseInt(Math.abs(Math.round(IPCurrent.difftime)));

    if (parseInt(IPCurrent.difftime) < 0) {
      datatimeCompA = Moment()
        .subtract(valorDiferenca, "seconds")
        .format("YYYY/MM/DD HH:mm:ss");
    } else {
      datatimeCompA = Moment()
        .add(valorDiferenca, "seconds")
        .format("YYYY/MM/DD HH:mm:ss");
    }

    duracaoFPause = Moment(datatimeCompA).diff(dataStatusA, "seconds");
    duracaoFPause = duracaoFPause < 0 ? 0 : duracaoFPause;

    return (
      <div style={{ minWidth: "65px" }}>
        <TimeCounterMinute
          horario={parseInt(duracaoFPause)}
          key={user.iduser + user.status + user.tmfuturepause}
        />
      </div>
    );
  }

  const renderPopoverInfo = (e, number, contact) => (
    <div className=" context-menu" id="drop-info-contact">
      <ul className="context-menu__list">
        <li className="contact-info">
          <PERSON />
          <div className="contact-info__name">
            {contact === -1 ? number : contact}
          </div>
        </li>

        <li className="contact-info">
          <OUTLINECALL />
          <div className="contact-info__name">{number}</div>
        </li>
      </ul>
    </div>
  );

  function renderNumbInfo(user) {
    if (
      user.status_sip === "LV" &&
      user.status === "AT" &&
      user.status_sip !== "QAT"
    ) {
      return (
        <Topover
          interactive={true}
          content={renderPopoverInfo(this, user.speaknum, user.razao_bloqueio)}
        >
          <div
            className="card__content__number tippy-default"
            data-tippy-placement="top"
          >
            <Call />
            <div
              className={`card__content__number-number ${
                (user.speaknum && user.speaknum.length > 11) ||
                (user.razao_bloqueio && user.razao_bloqueio.length > 11)
                  ? "w-min"
                  : ""
              }`}
            >
              {user.speaknum || user.razao_bloqueio}
            </div>
          </div>
        </Topover>
      );
    } else if (user.status_sip === "QAT") {
      return (
        <Topover
          interactive={true}
          content={renderPopoverInfo(this, user.speaknum, user.razao_bloqueio)}
        >
          <div
            className="card__content__number tippy-default"
            data-tippy-placement="top"
          >
            <Call />
            <div
              className={`card__content__number-number ${
                (user.speaknum && user.speaknum.length > 11) ||
                (user.razao_bloqueio && user.razao_bloqueio.length > 11)
                  ? "w-min"
                  : ""
              }`}
            >
              {user.speaknum || user.razao_bloqueio}
            </div>
          </div>
        </Topover>
      );
    } else if (user.status_sip === "RV" && user.status === "ATOS") {
      return (
        <Topover
          interactive={true}
          content={renderPopoverInfo(this, user.speaknum, user.razao_bloqueio)}
        >
          <div
            className="card__content__number tippy-default"
            data-tippy-placement="top"
          >
            <Call />
            <div
              className={`card__content__number-number ${
                user.speaknum && user.speaknum.length > 11 ? "w-min" : ""
              }`}
            >
              {user.speaknum}
            </div>
          </div>
        </Topover>
      );
    } else if (user.status_sip === "LV" && user.status === "RV") {
      return (
        <Topover
          interactive={true}
          content={renderPopoverInfo(this, user.speaknum, user.razao_bloqueio)}
        >
          <div
            className="card__content__number tippy-default"
            data-tippy-placement="top"
          >
            <Call />
            <div
              className={`card__content__number-number ${
                user.speaknum && user.speaknum.length > 11 ? "w-min" : ""
              }`}
            >
              {user.speaknum}
            </div>
          </div>
        </Topover>
      );
    } else if (user.status_sip === "CHND" && user.razao_bloqueio != "CHND") {
      return (
        <Topover
          interactive={true}
          content={renderPopoverInfo(this, user.speaknum, user.razao_bloqueio)}
        >
          <div
            className="card__content__number tippy-default"
            data-tippy-placement="top"
          >
            <Call />
            <div
              className={`card__content__number-number ${
                user.speaknum && user.speaknum.length > 11 ? "w-min" : ""
              }`}
            >
              {user.speaknum}
            </div>
          </div>
        </Topover>
      );
    } else if (user.status_sip === "ACW" && user.status === "ACW") {
      return (
        <div
          className="card__content__number tippy-default"
          data-tippy-placement="top"
        >
          <Call />
          <div
            className={`card__content__number-number ${
              user.razao_bloqueio && user.razao_bloqueio.length > 11
                ? "w-min"
                : ""
            }`}
          >
            {user.razao_bloqueio}
          </div>
        </div>
      );
      // } else if (user.status_sip === "BQ" && user.razao_bloqueio != "") {
      //   return (
      //     <div
      //       className="card__content__number tippy-default"
      //       data-tippy-placement="top"
      //       data-tippy-content="Maria Bernandes Dourado"
      //     >
      //       {user.razao_bloqueio}
      //     </div>
      //   );
    } else if (user.status_sip === "ACW" && user.status != "ACW") {
      return (
        <div
          className="card__content__number tippy-default"
          data-tippy-placement="top"
        >
          AfterCallWork
        </div>
      );
    } else if (user.status_sip === "AT" && user.status === "AT") {
      return (
        <Topover
          interactive={true}
          content={renderPopoverInfo(this, user.speaknum, user.razao_bloqueio)}
        >
          <div
            className="card__content__number tippy-default"
            data-tippy-placement="top"
          >
            <Call />
            <div
              className={`card__content__number-number ${
                (user.speaknum && user.speaknum.length > 11) ||
                (user.razao_bloqueio && user.razao_bloqueio.length > 11)
                  ? "w-min"
                  : ""
              }`}
            >
              {user.speaknum || user.razao_bloqueio}
            </div>
          </div>
        </Topover>
      );
    } else if (user.status_sip === "ATOS" && user.status === "AT") {
      return (
        <Topover
          interactive={true}
          content={renderPopoverInfo(this, user.speaknum, user.razao_bloqueio)}
        >
          <div
            className="card__content__number tippy-default"
            data-tippy-placement="top"
          >
            <Call />
            <div
              className={`card__content__number-number ${
                user.speaknum && user.speaknum.length > 11 ? "w-min" : ""
              }`}
            >
              {user.speaknum}
            </div>
          </div>
        </Topover>
      );
    } else if (user.status_sip === "AT" && user.status === "ATOS") {
      return (
        <Topover
          interactive={true}
          content={renderPopoverInfo(this, user.speaknum, user.razao_bloqueio)}
        >
          <div
            className="card__content__number tippy-default"
            data-tippy-placement="top"
          >
            <Call />
            <div
              className={`card__content__number-number ${
                user.speaknum && user.speaknum.length > 11 ? "w-min" : ""
              }`}
            >
              {user.speaknum}
            </div>
          </div>
        </Topover>
      );
    }
  }

  function getMediaId(user) {
    let findMidia = "";
    if (
      (user.mediaid === "null" || user.mediaid === "null") &&
      user.jsoncall &&
      (user.speaknum || user.razao_bloqueio)
    ) {
      let jsonSplit = user.jsoncall.split("¿");
      let jsonMediaid = jsonSplit.filter((split) =>
        split.includes(user.speaknum || user.razao_bloqueio),
      );
      let getMidia =
        jsonMediaid.length > 0 ? jsonMediaid[0].split("§")[0] : null;
      findMidia = getMidia;
    }

    let midiaId =
      user.mediaid && user.mediaid !== "null" ? user.mediaid : findMidia;

    return midiaId;
  }

  function renderIconChannel(user) {
    let midiaId = getMediaId(user);

    if (midiaId === "1") {
      return (
        <>
          <img src={VOZ} alt="Ícone do Telefone" />
        </>
      );
    } else if (midiaId === "4") {
      return (
        <>
          <img src={FACEBOOK} alt="Ícone do Facebook" />
        </>
      );
    } else if (midiaId === "5" || midiaId === 5) {
      return (
        <>
          <img src={WHATSAPP} alt="Ícone do Whatsapp" />
        </>
      );
    } else if (midiaId === "6" || midiaId === 6) {
      return (
        <>
          <img src={INSTAGRAM} alt="Ícone do Instagram" />
        </>
      );
    } else if (midiaId === "8" || midiaId === 8) {
      return (
        <>
          <img src={TELEGRAM} alt="Ícone do Telegram" />
        </>
      );
    } else if (midiaId === "2" || midiaId === 2) {
      return (
        <>
          <img src={WEBCHAT} alt="Ícone do Webchat" />
        </>
      );
    } else if (midiaId === "11" || midiaId === 11) {
      return (
        <>
          <img src={GOOGLEGBM} alt="Ícone do Google GBM" />
        </>
      );
    } else if (midiaId === "15" || midiaId === 15) {
      return (
        <>
          <img src={TEAMS} alt="Ícone do teams" />
        </>
      );
    } else if (midiaId === "16" || midiaId === 16) {
      return (
        <>
          <img src={WHATSAPPVOICE} alt="Ícone do whatsapp voz" />
        </>
      );
    } else {
      return <i className="material-icons">perm_phone_msg</i>;
    }
  }

  function renderIconInfo(user) {
    let midiaId = getMediaId(user);
    let midiaIsVoice = parseInt(midiaId) === 1 || parseInt(midiaId) === 16;

    if (
      user.status_sip === "LV" &&
      user.status === "AT" &&
      user.status_sip !== "QAT"
    ) {
      return (
        <div className="card__content__status-info-item">
          {renderIconChannel(user)}
          <div className="pausa-content pausa-btn--chmd-ativa">
            <div className="background-tick "></div>
            Atendimento
          </div>
        </div>
      );
    } else if (
      (user.status_sip === "AT" && user.status === "AT") ||
      (user.status_sip === "RV" && user.status === "ATOS")
    ) {
      return (
        <div className="card__content__status-info-item">
          {renderIconChannel(user)}
          <div className="pausa-content pausa-btn--chmd-ativa">
            <div className="background-tick "></div>
            Atendimento
          </div>
        </div>
      );
    } else if (user.status_sip === "QAT") {
      return (
        <Tooltippy content={user.direcao}>
          <div className="card__content__status-info-item">
            <div className="pausa-content pausa-btn--chmd-consulta">
              <div className="background-tick "></div>
              Em consulta
            </div>
          </div>
        </Tooltippy>
      );
    } else if (
      (user.status_sip === "AT" && user.status === "ATOS") ||
      (user.status_sip === "ATOS" && user.status === "AT")
    ) {
      return (
        <div className="card__content__status-info-item">
          {renderIconChannel(user)}
          <div className="pausa-content pausa-btn--chmd-ativa">
            <div className="background-tick "></div>
            Atendimento
          </div>
        </div>
      );
    } else if (user.status_sip === "LV" && user.status === "RV") {
      return (
        <div className="card__content__status-info-item">
          <i className="material-icons">phone_in_talk</i>
          <div className="pausa-content pausa-btn--chmd-ativa">
            <div className="background-tick "></div>
            Discando
          </div>
        </div>
      );
    } else if (user.status_sip === "CHND" && user.razao_bloqueio !== "CHND") {
      return (
        <div className="card__content__status-info-item">
          <i className="material-icons">phone_in_talk</i>
          <div
            className={`pausa-content ${parseInt(user.directionChnd) === 1 ? "pausa-btn--chmd-receptiva" : "pausa-btn--chmd-ativa"}`}
          >
            <div className="background-tick "></div>
            Chamando
            {` - ${parseInt(user.directionChnd) === 1 ? "Receptivo" : "Ativo"}`}
          </div>
        </div>
      );
    } else if (user.status_sip === "BQ" && user.razao_bloqueio != "") {
      return (
        <div className="card__content__status-info-item">
          <div className="pausa-content pausa-btn--pausado">
            <div className="background-tick "></div>
            Pausado
          </div>
        </div>
      );
    } else if (user.status_sip === "ACW" && user.status === "ACW") {
      return (
        <div className="card__content__status-info-item">
          {renderIconChannel(user)}
          <div className="pausa-content pausa-btn--after-call">
            <div className="background-tick "></div>
            AfterCallWork
          </div>
        </div>
      );
    } else if (
      user.status_sip === null ||
      user.status === null ||
      user.status_sip === "null" ||
      user.status === "null"
    ) {
      return (
        <div className="card__content__status-info-item">
          <div className="pausa-content pausa-btn--inativo">
            <div className="background-tick "></div>
            Inativo
          </div>
        </div>
      );
    } else if (user.status_sip === "LV" && user.status === "LV") {
      return (
        <div className="card__content__status-info-item">
          <div className="pausa-content pausa-btn--livre">
            <div className="background-tick "></div>
            Livre
          </div>
        </div>
      );
    } else if (user.status_sip === "RV" && user.status === "LV") {
      return (
        <div className="card__content__status-info-item ">
          <div className="pausa-content pausa-btn--livre">
            <div className="background-tick "></div>
            Livre
          </div>
        </div>
      );
    } else if (user.status_sip === "BQSUPER" && user.status === "BQSUPER") {
      return (
        <div className="card__content__status-info-item">
          <i className="material-icons">phone_paused</i>
          <div className="pausa-content pausa-btn--pausado">
            <div className="background-tick "></div>
            Bloqueado
          </div>
        </div>
      );
    }
  }

  function timeLastStatus(user, IPCurrent) {
    let duracao = "";
    if (user.duration != null) {
      let arrayCompA = user.duration.split("-");
      let datatimeCompA = Moment().format("YYYY/MM/DD HH:mm:ss");
      //var valorDiferenca = parseInt(Math.abs(Math.round(IPCurrent.difftime)));

      let valorDiferenca = datatimeCompA;

      if (parseInt(IPCurrent.difftime) < 0) {
        datatimeCompA = Moment()
          .subtract(valorDiferenca, "seconds")
          .format("YYYY/MM/DD HH:mm:ss");
      } else {
        datatimeCompA = Moment()
          .add(valorDiferenca, "seconds")
          .format("YYYY/MM/DD HH:mm:ss");
      }

      // let dataStatusA = Moment(arrayCompA[0], "DD/MM/YYYY HH:mm:ss").format(
      //   "YYYY/MM/DD HH:mm:ss"
      // );

      // let dataStatusA = Moment(arrayCompA[0], "YYYY/MM/DD HH:mm:ss").format(
      //   "YYYY/MM/DD HH:mm:ss"
      // );

      let dataStatusA = Moment(arrayCompA[0], "DD/MM/YYYY HH:mm:ss").format(
        "YYYY/MM/DD HH:mm:ss",
      );

      duracao = Moment(valorDiferenca).diff(dataStatusA, "seconds");
      duracao = duracao < 0 ? 0 : duracao;
    }

    if (
      user.status_sip === "LV" &&
      user.status === "AT" &&
      user.status_sip !== "QAT"
    ) {
      return (
        <div
          className="card__content__info__item"
          key={"intmng" + user.value + "_" + user.status_sip + user.speaknum}
        >
          <TempoUltimoStatus />
          <TimeCounterInternal
            horario={parseInt(duracao)}
            key={"intmng" + user.value + "_" + user.status_sip + user.speaknum}
          />
        </div>
      );
    }
    if (user.status_sip === "QAT") {
      return (
        <div
          className="card__content__info__item"
          key={"intmng" + user.value + "_" + user.status_sip + user.speaknum}
        >
          <TempoUltimoStatus />
          <TimeCounterInternal
            horario={parseInt(duracao)}
            key={"intmng" + user.value + "_" + user.status_sip + user.speaknum}
          />
        </div>
      );
    } else if (user.status_sip === "LV" && user.status === "RV") {
      return (
        <div
          className="card__content__info__item"
          key={
            "intmng" +
            user.value +
            "_" +
            user.status_sip +
            "_" +
            user.speaknum +
            "_1"
          }
        >
          <TempoUltimoStatus />
          <TimeCounterInternal
            horario={parseInt(duracao)}
            key={
              "intmng" +
              user.value +
              "_" +
              user.status_sip +
              "_" +
              user.speaknum +
              "_2"
            }
          />
        </div>
      );
    } else if (user.status_sip === "RV" && user.status === "ATOS") {
      return (
        <div>
          <div
            style={{ display: "none" }}
            className="pausa-content pausa-btn--inativo"
          >
            <i className="material-icons">phone_locked</i>
            Inativo
          </div>
          <div
            className="card__content__info__item"
            key={
              "intmng" +
              user.value +
              "_" +
              user.status_sip +
              "_" +
              user.speaknum +
              "_3"
            }
          >
            <TempoUltimoStatus />
            <TimeCounterInternal
              horario={parseInt(duracao)}
              key={
                "intmng" +
                user.value +
                "_" +
                user.status_sip +
                "_" +
                user.speaknum +
                "_4"
              }
            />
          </div>
        </div>
      );
    } else if (user.status_sip === "AT" && user.razao_bloqueio !== "AT") {
      return (
        <div
          className="card__content__info__item"
          key={
            "intmng" +
            user.value +
            "_" +
            user.status_sip +
            "_" +
            user.speaknum +
            "_5"
          }
        >
          <TempoUltimoStatus />
          <TimeCounterInternal
            horario={parseInt(duracao)}
            key={
              "intmng" +
              user.value +
              "_" +
              user.status_sip +
              "_" +
              user.speaknum +
              "_6"
            }
          />
        </div>
      );
    } else if (user.status_sip === "CHND" && user.razao_bloqueio !== "CHND") {
      return (
        <div
          className="card__content__info__item"
          key={
            "intmng" +
            user.value +
            "_" +
            user.status_sip +
            "_" +
            user.speaknum +
            "_7"
          }
        >
          <TempoUltimoStatus />
          <TimeCounterInternal
            horario={parseInt(duracao)}
            key={
              "intmng" +
              user.value +
              "_" +
              user.status_sip +
              "_" +
              user.speaknum +
              "_8"
            }
          />
        </div>
      );
    } else if (user.status_sip === "ACW" && user.status === "ACW") {
      return (
        <div
          className="card__content__info__item"
          key={
            "intmng" +
            user.value +
            "_" +
            user.status_sip +
            "_" +
            user.speaknum +
            "_9"
          }
        >
          <TempoUltimoStatus />
          <TimeCounterInternal
            horario={parseInt(duracao)}
            key={
              "intmng" +
              user.value +
              "_" +
              user.status_sip +
              "_" +
              user.speaknum +
              "_10"
            }
          />
        </div>
      );
    } else if (user.status_sip === "BQ" && user.razao_bloqueio != "") {
      return (
        <div
          className="card__content__info__item"
          key={
            "intmng" +
            user.value +
            "_" +
            user.status_sip +
            "_" +
            user.speaknum +
            "_11"
          }
        >
          <TempoUltimoStatus />
          <TimeCounterInternal
            horario={parseInt(duracao)}
            key={
              "intmng" +
              user.value +
              "_" +
              user.status_sip +
              "_" +
              user.speaknum +
              "_12"
            }
          />
        </div>
      );
    } else if (user.status_sip === "LV" && user.status === "LV") {
      return (
        <div>
          <div
            style={{ display: "none" }}
            className="pausa-content pausa-btn--pausado"
          >
            <i className="material-icons">phone_paused</i>
            Pausa
          </div>
          <div
            className="card__content__info__item"
            key={
              "intmng" +
              user.value +
              "_" +
              user.status_sip +
              "_" +
              user.speaknum +
              "_13"
            }
          >
            <TempoUltimoStatus />
            <TimeCounterInternal
              horario={parseInt(duracao)}
              key={
                "intmng" +
                user.value +
                "_" +
                user.status_sip +
                "_" +
                user.speaknum +
                "_14"
              }
            />
          </div>
        </div>
      );
    } else if (user.status_sip === "BQSUPER" && user.status === "BQSUPER") {
      return (
        <div>
          <div
            style={{ display: "none" }}
            className="pausa-content pausa-btn--pausado"
          >
            <i className="material-icons">phone_paused</i>
            Bloqueado
          </div>
          <div
            className="card__content__info__item"
            key={
              "intmng" +
              user.value +
              "_" +
              user.status_sip +
              "_" +
              user.speaknum +
              "_15"
            }
          >
            <TempoUltimoStatus />
            <TimeCounterInternal
              horario={parseInt(duracao)}
              key={
                "intmng" +
                user.value +
                "_" +
                user.status_sip +
                "_" +
                user.speaknum +
                "_16"
              }
            />
          </div>
        </div>
      );
    }
  }

  function renderCard() {
    if (user.visible === true) {
      let classNameColor = "";
      let className = "card card--med card--med__expand";

      if (user.status_sip === "CHND" && user.razao_bloqueio != "CHND") {
        className = "card card--med card--med__expand card--calling card--blue";
      }

      if (user.superinfo) {
        className = "card card--med card--med__expand card--red card--calling";
      }

      if (user.status === "ACW" && user.status_sip === "ACW") {
        className = "card card--med card--med__expand card--red card--yellow";
      }

      if (
        (user.status_sip === "LV" && user.status === "AT") ||
        (user.status_sip === "AT" && user.status === "AT") ||
        (user.status_sip === "RV" && user.status === "ATOS") ||
        (user.status_sip === "AT" && user.status === "ATOS") ||
        (user.status_sip === "ATOS" && user.status === "AT") ||
        (user.status_sip === "LV" && user.status === "RV") ||
        (user.status_sip === "CHND" && user.razao_bloqueio != "CHND")
      ) {
        classNameColor = "card--chmd-ativa";
      } else if (user.status_sip === "QAT") {
        classNameColor = "card--chmd-consulta";
      } else if (
        (user.status_sip === "BQ" && user.razao_bloqueio != "") ||
        (user.status_sip === "BQSUPER" && user.status === "BQSUPER")
      ) {
        classNameColor = "card--pausado";
      } else if (user.status_sip === "ACW" && user.status === "ACW") {
        classNameColor = "card--after-call";
      } else if (
        user.status_sip === null ||
        user.status === null ||
        user.status_sip === "null" ||
        user.status === "null"
      ) {
        classNameColor = "card--inativo";
      } else if (
        (user.status_sip === "LV" && user.status === "LV") ||
        (user.status_sip === "RV" && user.status === "LV")
      ) {
        classNameColor = "card--livre";
      }

      return (
        <div className="card__wrapper">
          <div
            className={
              user.status_sip === "CHND" && user.razao_bloqueio != "CHND"
                ? `card card--box-med card--med__expand card--calling ${parseInt(user.directionChnd) === 1 ? "card--pink" : "card--purple"}`
                : user.superinfo
                  ? "card card--box-med card--med__expand card--red card--calling"
                  : `card card--box-med card--med__expand ${classNameColor}`
            }
          >
            <div className="flex">
              <div className="card__content__status">
                {renderIconInfo(user)}
                {user.status_sip === "BQ" && user.razao_bloqueio != "" && (
                  <Tooltippy content={user.razao_bloqueio}>
                    <div className="card__content__grupo">
                      <div className="card__content__grupo__item">
                        {user.razao_bloqueio}
                      </div>
                    </div>
                  </Tooltippy>
                )}
              </div>
              <div className="card__content">
                <div className="card__content-user_info">
                  <UserPhoto
                    size="large"
                    link={user.imgUser ? user.imgUser : false}
                  />
                  <div className="info">
                    <div className="card__content__title">
                      <div className="card__content__title__name-content">
                        <div className="text">{user.label}</div>
                        <Tooltippy
                          content={user.desc_grupo + " - " + user.ramal}
                        >
                          <div className="ramal">
                            <span className="group-name">
                              {user.desc_grupo}
                            </span>{" "}
                            - {user.ramal}
                          </div>
                        </Tooltippy>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="card__content__info">
                    {renderNumbInfo(user)}
                    {user.dtl === "Received: INFO" || user.dtl === 0 ? (
                      ""
                    ) : (
                      <div className="card__content__info__item">
                        <HorasLogin />
                        {typeOfPeriod(user)}:{" "}
                        {parseInt(user.duration) === 0
                          ? null
                          : Moment(user.duration, "DD/MM/YYYY HH:mm:ss").format(
                              "HH:mm",
                            )}
                      </div>
                    )}
                    <div className="card__content__info__item">
                      <CalendarTeam />
                      {datalogin}
                    </div>
                    {timeLastStatus(user, IPCurrent)}
                  </div>
                  {(() => {
                    if (parseInt(user.futurepause) === 1) {
                      return (
                        <div
                          key={
                            "futurepause" +
                            user.value +
                            "_" +
                            user.descfuturepause
                          }
                          className={"card__content__info__pausa"}
                        >
                          <div className="pausa__futura-btn__new-container">
                            <div className="pausa__futura-btn active">
                              <span className="pausa__futura-btn-dot"></span>
                              <FuturePauseIcon />
                            </div>
                            <Tooltippy
                              content={
                                user.descfuturepause ? user.descfuturepause : ""
                              }
                            >
                              <span className="pausa__futura-descricao ellipsis-hidden">
                                {user.countfpause} • {user.descfuturepause}
                              </span>
                            </Tooltippy>
                            {timeFuturePause(user, IPCurrent)}
                          </div>
                        </div>
                      );
                    } else if (
                      user.countfpause !== undefined &&
                      parseInt(user.countfpause) > 0
                    ) {
                      return (
                        <div
                          key={
                            "futurepause" + user.value + "_" + user.countfpause
                          }
                          className={"card__content__info__pausa"}
                        >
                          <div className="pausa__futura-btn active">
                            <FuturePauseStatic />
                          </div>
                          <span className="pausa__futura-descricao">
                            {user.countfpause}
                          </span>
                        </div>
                      );
                    }
                  })()}
                </div>
              </div>
            </div>
            <div
              className={
                InfoUsers.supervisor === true
                  ? "monitorias"
                  : "monitorias monitorias--secondary"
              }
            >
              <Tooltippy content={"Enviar Mensagem"}>
                <a
                  onClick={(event) =>
                    handleInitialChat(event, ChatSimult, user)
                  }
                  className="monitorias__item tippy-default"
                  data-tippy-placement="top"
                  data-tippy-content="Enviar mensagem"
                >
                  <EMCURSO />
                </a>
              </Tooltippy>

              {(() => {
                let containsOne = false;
                if (user && user.jsoncall) {
                  containsOne = user.jsoncall
                    .split("¿")
                    .some((part) => part.split("§").includes("1"));
                }

                if (InfoUsers.enablecallvoz) {
                  if (
                    (user.status === "AT" && parseInt(user.mediaid) === 1) ||
                    user.status === null ||
                    user.status_sip === null ||
                    user.status_sip === "null" ||
                    user.status === "null"
                  ) {
                    return (
                      <Tooltippy content={"Consulta"}>
                        <a
                          className="monitorias__item tippy-default desabled"
                          data-tippy-placement="top"
                          data-tippy-content="Falar com atendente"
                        >
                          <Call />
                        </a>
                      </Tooltippy>
                    );
                  } else if (containsOne) {
                    return (
                      <Tooltippy content={"Consulta"}>
                        <a
                          className="monitorias__item tippy-default desabled"
                          data-tippy-placement="top"
                          data-tippy-content="Falar com atendente"
                        >
                          <Call />
                        </a>
                      </Tooltippy>
                    );
                  } else {
                    // let checkAnswerInitial = getState().ChatSimult;
                    return (
                      <Tooltippy content={"Consulta"}>
                        <a
                          onClick={(event) =>
                            handleInitialCall(
                              event,
                              PermissionRouter,
                              1,
                              OutBandService,
                              InfoUsers,
                              StatusAgent.status,
                              listCallQueue,
                              user.ramal,
                              IPCurrent,
                              ChatSimult,
                              user,
                            )
                          }
                          className="monitorias__item tippy-default"
                          data-tippy-placement="top"
                          data-tippy-content="Falar com atendente"
                        >
                          <Call />
                        </a>
                      </Tooltippy>
                    );
                  }
                }
              })()}

              {(() => {
                if (InfoUsers.supervisor === true)
                  return (
                    <>
                      <Tooltippy content={"Escuta Sigilosa"}>
                        <a
                          onClick={(e) =>
                            handleInitialMonitoring(
                              e,
                              InfoUsers.id,
                              user.iduser,
                              user.label,
                              MonitoringSimult,
                              "1",
                              user.ramal,
                              user.jsoncall,
                            )
                          }
                          className="monitorias__item tippy-default"
                          data-tippy-placement="top"
                          data-tippy-content="Escuta sigilosa"
                        >
                          <SIGILOSA />
                        </a>
                      </Tooltippy>
                      <Tooltippy content={"Sussurro"}>
                        <a
                          onClick={(e) =>
                            handleInitialMonitoring(
                              e,
                              InfoUsers.id,
                              user.iduser,
                              user.label,
                              MonitoringSimult,
                              "2",
                              user.ramal,
                              user.jsoncall,
                            )
                          }
                          className="monitorias__item tippy-default"
                          data-tippy-placement="top"
                          data-tippy-content="Sussurro"
                        >
                          <SUSSURRO />
                        </a>
                      </Tooltippy>
                      <Tooltippy content={"Intercalar"}>
                        <a
                          onClick={(e) =>
                            handleInitialMonitoring(
                              e,
                              InfoUsers.id,
                              user.iduser,
                              user.label,
                              MonitoringSimult,
                              "3",
                              user.ramal,
                              user.jsoncall,
                            )
                          }
                          className="monitorias__item tippy-default"
                          data-tippy-placement="top"
                          data-tippy-content="Intercalar"
                        >
                          <INTERCALAR />
                        </a>
                      </Tooltippy>
                      <Tooltippy content={"Bloquear"}>
                        <a
                          onClick={(event) =>
                            handleShowModal(
                              event,
                              user.iduser,
                              user.status_sip,
                              user.razao_bloqueio,
                              user.duration,
                              user.status,
                            )
                          }
                          className="monitorias__item tippy-default"
                          data-tippy-placement="top"
                          data-tippy-content="Bloqueio"
                        >
                          <BLOQUEIO />
                        </a>
                      </Tooltippy>
                    </>
                  );
              })()}
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  return <>{renderCard()}</>;
};

export default React.memo(CardUser, (prevProps, nextProps) => {
  return _.isEqual(prevProps.user, nextProps.user);
});
